import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const Results = () => {

    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [tests, setTests] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState('');
    // localStorage.removeItem('answers');

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        // console.log(filters);
        let filteredItems = [...tests];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);

    const getTests = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/result_test',
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setTests(response.data.tests);
            setFilteredData(response.data.tests);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        localStorage.removeItem('resultId');
        getTests();
    }, []);

    const viewTest = (uid) => {
        localStorage.setItem('tId', uid);
        navigate('/view_test');

    }
    const userTest = (uid) => {
        localStorage.setItem('tId', uid);
        navigate('/user_test');

    }

    const editTest = (uid) => {
        localStorage.setItem('editTest', uid);
        navigate('/edit_test');

    }

    const getResult = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            console.log("calling api to get result");
            const response = await axios.post(
                apipath + '/getResults', { 'testId': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getTests();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const deleteTest = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/delete_result', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getTests();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const confirmDeletion = (uid) => {
        iziToast.show({
            color: 'red',
            message: 'Confirm Deletion',
            position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
            buttons: [
                [
                    '<button>Ok</button>',
                    function (instance, toast) {
                        deleteTest(uid);
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ],
                [
                    '<button>Close</button>',
                    function (instance, toast) {
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ]
            ]
        });
    }

    const testStatus = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/result_status', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getTests();
            }

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    const downloadStatus = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/result_download_status', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getTests();
            }

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    const noResult = () => {
        iziToast.warning({
            message: "Result can't be Generated before Result Time",
            position: "topCenter"
        })
    }
    const [activeTab, setActiveTab] = useState("Test");

    const [searchText, setSearchText] = useState("");

    // Sample data for the table
    // const data = [
    //     { name: "John Doe", email: "john@example.com", organization: "John", tests: "5", subjects: "Hindi, English, Reasoning", pincode: "125052" },
    //     { name: "Jane Smith", email: "jane@example.com", organization: "Jane", tests: "8", subjects: "Hindi, English, Maths", pincode: "125052" },
    //     { name: "Alice Johnson", email: "alice@example.com", organization: "Alice", tests: "3", subjects: "GK, Hindi, English, Aptitude", pincode: "125052" },
    //     { name: "Bob Brown", email: "bob@example.com", organization: "Bob", tests: "6", subjects: "India GK, Reasoning, Aptitude", pincode: "125052" },
    // ];

    // Define columns for the table
    const viewResult = (resultId) => {
        localStorage.setItem('resultId', resultId);
        navigate('/view_result');
    }
    // <i class="fa fa-file rounded p-1 ml-1 cursor-pointer text-orange-500 hover:text-white border-2 border-orange-500 hover:bg-orange-500" title="attempt test" onClick={() => userTest(row.id)}></i>

    const columns = [
        { name: "Sr.", selector: (row, index) => index + 1, sortable: false, width: '50px' },
        { name: "Test Name", selector: (row) => row.test?.test_name, sortable: true, },
        { name: "Exam", selector: (row) => row.exam?.exam_name, sortable: true, },
        { name: "Organization", selector: (row) => row.organization?.name, sortable: true, },
        { name: "Test Time", selector: (row) => row.start_time, sortable: true, },
        { name: "Result Time", selector: (row) => row.result_time, sortable: true, },
        {
            name: "Release Status", selector: (row) => <>
                {(userType === 'admin') ? ((row.result_status === 'true') ? "Released" : "Pending") : <input type="checkbox" onClick={() => testStatus(row.id)} checked={(row.result_status === 'true')} title={(row.result_status === "true") ? 'Active' : 'In-Active'} />}
            </>, sortable: true,
        },
        {
            name: "Download Status", selector: (row) => <>
                {(userType === 'admin') ? ((row.download_status === 'true') ? "Yes" : "No") : <input type="checkbox" onClick={() => downloadStatus(row.id)} checked={(row.download_status === 'true')} title={(row.download_status === "true") ? 'Yes' : 'No'} />}
            </>, sortable: true,
        },
        {
            name: "Action", selector: (row) => {
                const now = new Date();
                const resultTime = new Date(row.result_time);
                return (
                    (userType === 'super_admin') ?
                        (row.result === 'true') ?
                            <>
                                <i onClick={() => viewResult(row.id)} className="fa fa-eye p-1 text-teal-600 rounded border-2 border-teal-600 hover:bg-teal-600 hover:text-white hover:border-transparent"></i>
                                <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white border-2 border-red-600 hover:bg-red-600" title="delete result" onClick={() => confirmDeletion(row.id)}></i>
                            </> : <>
                                <i onClick={() => (resultTime > now) ? noResult() : getResult(row.id)} className="fa fa-arrow-down p-1 text-teal-900 rounded border-2 border-teal-900 hover:bg-teal-900 hover:text-white hover:border-transparent" title="get result"></i>
                                <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white border-2 border-red-600 hover:bg-red-600" title="delete result" onClick={() => confirmDeletion(row.id)}></i>
                            </> :
                        <>
                            <i onClick={() => (row.result_status === "true") ? viewResult(row.id) : ""} className="fa fa-eye p-1 text-teal-600 rounded border-2 border-teal-600 hover:bg-teal-600 hover:text-white hover:border-transparent" data-status={`${row.result_status}`} disabled={(row.result_status === "false")} ></i>
                        </>
                )}, sortable: true,
        },
    ];
    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"results"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 shadow text-2xl text-white relative">
                            <h3 class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Results</h3>
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Exams</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={filters}
                                    onChange={(e) => setFilters(e.target.value)}
                                    className="p-1.5 shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]"
                                />
                                {/* <Link to={`/add_test`}><button className="p-1 text-sm font-bold text-teal-900 rounded-lg border-2 border-teal-900 hover:bg-teal-900 hover:text-white hover:border-transparent">
                                    + Add
                                </button></Link> */}
                            </div>
                            <div className="max-h-[70vh] overflow-auto shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]">

                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};